import { render, staticRenderFns } from "./ResultadoApi.vue?vue&type=template&id=ff5da01c&scoped=true&"
import script from "./ResultadoApi.vue?vue&type=script&lang=js&"
export * from "./ResultadoApi.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoApi.vue?vue&type=style&index=0&id=ff5da01c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5da01c",
  null
  
)

export default component.exports